/* ═══════════════════════════════════════════════════════════════
   ═══════════════════════════════════════════════════════════════
   Tüm componentlerin kullanabileceği merkezi renk sistemi.
   Import:  import { P, G, S } from '../theme/palette';
   ═══════════════════════════════════════════════════════════════ */

const blue = {
  50:  '#e6f9ff',
  100: '#b3eeff',
  200: '#66dcff',
  300: '#33d0ff',
  400: '#1ac8ff',
  500: '#03c0ff',
  600: '#02a8e0',
  700: '#0187b3',
  800: '#016686',
  900: '#014d66',
};

const teal = {
  50:  '#fff8f0',
  100: '#ffedd5',
  200: '#fed7aa',
  300: '#fdb858',
  400: '#fda832',
  500: '#fc8d05',
  600: '#d97604',
  700: '#b35f03',
};

/* ── Accent: Deep Orange (badges, highlights) ── */
const accent = {
  50:  '#fff8f0',
  100: '#ffedd5',
  200: '#fed7aa',
  300: '#fdb858',
  400: '#fc8d05',
  500: '#e07d04',
  600: '#d97604',
  700: '#b35f03',
};

/* ── Neutral (Slate) ── */
const neutral = {
  0:   '#ffffff',
  50:  '#f8fafc',
  100: '#f1f5f9',
  200: '#e2e8f0',
  300: '#cbd5e1',
  400: '#94a3b8',
  500: '#64748b',
  600: '#475569',
  700: '#334155',
  800: '#1e293b',
  900: '#0f172a',
};

/* ── Dark backgrounds ── */
const dark = {
  bg1: '#0f0f23',
  bg2: '#1a1a2e',
  card: 'rgba(255,255,255,0.06)',
  cardBorder: 'rgba(255,255,255,0.1)',
  cardHover: 'rgba(255,255,255,0.1)',
  cardBorderHover: 'rgba(255,255,255,0.18)',
};

/* ═══════════════════════════════════════════
   P — Palette (flat access)
   ═══════════════════════════════════════════ */
export const P = { blue, teal, accent, neutral, dark };

/* ═══════════════════════════════════════════
   G — Gradients
   ═══════════════════════════════════════════ */
export const G = {
  /* Hero / Primary gradient */
  primary:     'linear-gradient(135deg, #03c0ff 0%, #fc8d05 100%)',
  primarySoft: 'linear-gradient(135deg, #33d0ff 0%, #fda832 100%)',
  primaryDark: 'linear-gradient(135deg, #0187b3 0%, #d97604 100%)',

  /* Background gradients */
  bgLight:     'linear-gradient(165deg, #e6f9ff 0%, #fff8f0 30%, #ffffff 70%)',
  bgDark:      'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
  bgSubtle:    'linear-gradient(180deg, #f8fafc 0%, #ffffff 50%, #f8fafc 100%)',

  /* Accent (badge decorative line) */
  accent:      'linear-gradient(90deg, #fc8d05 0%, #d97604 100%)',
  accentSoft:  'linear-gradient(135deg, #fda832 0%, #fc8d05 100%)',

  /* Card gradients */
  cardBlue:    'linear-gradient(135deg, #e6f9ff 0%, #b3eeff 100%)',
  cardTeal:    'linear-gradient(135deg, #fff8f0 0%, #ffedd5 100%)',
  cardOrange:  'linear-gradient(135deg, #fff8f0 0%, #ffedd5 100%)',

  /* Glow helpers (append opacity + ')' ) */
  glowBlue:    'rgba(3,192,255,',
  glowTeal:    'rgba(252,141,5,',
  glowAccent:  'rgba(252,141,5,',
};

/* ═══════════════════════════════════════════
   S — Shadows
   ═══════════════════════════════════════════ */
export const S = {
  sm:   '0 2px 8px rgba(0,0,0,0.04)',
  md:   '0 4px 20px rgba(0,0,0,0.06)',
  lg:   '0 12px 40px rgba(0,0,0,0.08)',
  xl:   '0 24px 64px rgba(0,0,0,0.10)',
  blue: `0 8px 32px rgba(3,192,255,0.15)`,
  teal: `0 8px 32px rgba(252,141,5,0.12)`,
  glow: `0 8px 32px rgba(3,192,255,0.25), 0 2px 8px rgba(252,141,5,0.15)`,
};

export default P;
